import api from '../api'
import _ from 'lodash'
import {
    ADD_BATCH,
    CHANGE_BATCH_CURRENT_PAGE,
    CHANGE_PROGRESS,
    REMOVE_SAMPLE_BATCH,
    UPDATE_AVAILABLE_BATCH_STATUSES_BY_VALUE,
    UPDATE_BATCH,
    UPDATE_BATCHES,
    UPDATE_MISSING_SAMPLES,
    UPDATE_SAMPLE_BATCH,
    UPDATE_SAMPLE_BATCH_LIST,
    UPDATE_CASES_WITH_MISSING_SAMPLES,
    UPDATE_ALL_BATCHES,
    UPDATE_BATCH_FILES,
    FULLFILL_BATCH
} from '../../batches/mutations/available'
import NotificationService from '../../../../services/notificationService'
import {extractUserErrorMessage} from '@/helpers/api'

export const getCasesWithMissingSamples = async ({state, dispatch, commit}) => {
    if (state.progress['getCasesWithMissingSamples']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getCasesWithMissingSamples', value: true})

    try {
        const result = await api.getCasesWithMissingSamples()
        commit(UPDATE_CASES_WITH_MISSING_SAMPLES, result)
    } catch (e) {
        NotificationService.error(`Unable to get cases with missing samples. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'getCasesWithMissingSamples', value: false})
}

export const moveSampleToArchive = async ({state, dispatch, commit}, id) => {
    if (state.progress['moveSampleToArchive']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'moveSampleToArchive', value: true})

    try {
        await api.moveSampleToArchive(id)
        dispatch('getMissingSamples')
    } catch (e) {
        NotificationService.error(`Unable to move sample to archive. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'moveSampleToArchive', value: false})
}

export const moveSampleToSuitableBatch = async ({state, dispatch, commit}, id) => {
    if (state.progress['moveSampleToSuitableBatch']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'moveSampleToSuitableBatch', value: true})

    try {
        const result = await api.moveSampleToSuitableBatch(id)
        dispatch('getMissingSamples')

        const batchSystemId = _.get(result, 'batchSystemId', null)
        const position = _.get(result, 'position', null)

        if (batchSystemId && position) {
            NotificationService.success(`Sample was successfully added to run ${batchSystemId} at position ${position}`)
        }

        const batchId = _.get(result, 'batchId', null)

        if (batchId) {
            dispatch('getSampleBatchList', batchId)
        }
    } catch (e) {
        NotificationService.error(`Unable to move sample to suitable run. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'moveSampleToSuitableBatch', value: false})
}

export const getMissingSamples = async ({state, dispatch, commit}) => {
    if (state.progress['getMissingSamples']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getMissingSamples', value: true})

    try {
        let missingSamples = await api.getMissingSamples()
        commit(UPDATE_MISSING_SAMPLES, missingSamples)
    } catch (e) {
        NotificationService.error(`Unable to get missing samples. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'getMissingSamples', value: false})
}

export const getBatches = async ({state, dispatch, commit}) => {
    if (state.progress['getBatches']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getBatches', value: true})
    const {page, rowsPerPage} = state.pagination

    try {
        let resultFilters = {
            ...state.filters,
        }

        let result = await api.getBatches((page - 1) * rowsPerPage, rowsPerPage, resultFilters)
        commit(UPDATE_BATCHES, {
            batches: result.batches,
            total: result.total
        })
    } catch (e) {
        console.log(e.message)
        NotificationService.error(`Unable to get run list. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'getBatches', value: false})
}

export const getBatch = async({state, commit}, batchId) => {
    try {
        let batch = await api.getBatch(batchId)
        commit(FULLFILL_BATCH, batch)
    } catch (e) {
        NotificationService.error(`Unable to get batch. Try again later`)
    }
}

export const getAllBatches = async({state, commit}) => {
    if (state.progress['getAllBatches']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getAllBatches', value: true})

    try {
        let result = await api.getAllBatches()
        commit(UPDATE_ALL_BATCHES, result)
    } catch (e) {
        NotificationService.error(`Unable to get run list. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'getAllBatches', value: false})
}

export const createBatch = async ({state, dispatch, commit}, batchData) => {
    if (state.progress['createBatch']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'createBatch', value: true})

    try {
        let createdBatch = await api.createBatch(batchData)
        commit(ADD_BATCH, createdBatch)
    } catch (e) {
        NotificationService.error(`Unable to create run. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'createBatch', value: false})
}

export const getSampleBatchList = async ({state, dispatch, commit}, batchId) => {
    if (state.progress['getSampleBatchList']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getSampleBatchList', value: true})

    try {
        let sampleBatchList = await api.getSampleBatchList(batchId)
        commit(UPDATE_SAMPLE_BATCH_LIST, {
            batchId,
            sampleBatchList,
        })
    } catch (e) {
        NotificationService.error(`Unable to get sample run list. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'getSampleBatchList', value: false})
}

export const setBatchCurrentPage = async ({state, dispatch, commit}, page) => {
    commit(CHANGE_BATCH_CURRENT_PAGE, page)
    dispatch('getBatches')
}

export const addSample = async ({state, dispatch, commit}, {sampleId, batchId, position}) => {
    if (state.progress['addSampleToBatch']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'addSampleToBatch', value: true})

    let result = false
    try {
        let sampleBatch = await api.addSample(sampleId, batchId, position)
        dispatch('deleteSampleFromBatches', sampleBatch)
        dispatch('getMissingSamples')
        commit(UPDATE_SAMPLE_BATCH, sampleBatch)
        result = true
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to add sample to run. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'addSampleToBatch', value: false})

    dispatch('getBatch', batchId)

    return result
}

export const updateSample = async ({state, dispatch, commit}, {id, sampleId, position}) => {
    if (state.progress['updateSampleToBatch']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'updateSampleToBatch', value: true})

    try {
        let sampleBatch = await api.updateSample(id, sampleId, position)
        dispatch('deleteSampleFromBatches', sampleBatch)
        commit(UPDATE_SAMPLE_BATCH, sampleBatch)
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to update sample in run. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'updateSampleToBatch', value: false})
}

export const removeSample = async ({state, dispatch, commit}, {position, sampleId, batchId}) => {
    if (state.progress['removeSampleFromBatch']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'removeSampleFromBatch', value: true})

    try {
        await api.removeSample(sampleId, batchId)
        commit(REMOVE_SAMPLE_BATCH, {
            position: position,
            batchId: batchId
        })

        dispatch('getMissingSamples')
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to remove sample from batch. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'removeSampleFromBatch', value: false})

    dispatch('getBatch', batchId)
}

export const shiftSamplesToLeft = async ({state, dispatch, commit}, {sampleBatchId, batchId}) => {
    if (state.progress['shiftSamplesToLeft']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'shiftSamplesToLeft', value: true})

    let result = false
    try {
        await api.shiftSamplesToLeft(sampleBatchId)
        dispatch('getSampleBatchList', batchId)
        result = true
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to shift samples to left. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'shiftSamplesToLeft', value: false})

    return result
}

export const shiftSamplesToRight = async ({state, dispatch, commit}, {sampleBatchId, batchId}) => {
    if (state.progress['shiftSamplesToRight']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'shiftSamplesToRight', value: true})

    let result = false
    try {
        await api.shiftSamplesToRight(sampleBatchId)
        dispatch('getSampleBatchList', batchId)
        result = true
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to shift samples to right. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'shiftSamplesToRight', value: false})

    return result
}

export const startBatchProcessing = async ({state, dispatch, commit}, {batchId, responsibleSpecialistId}) => {
    if (state.progress['startBatchProcessing']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'startBatchProcessing', value: true})

    let started = false

    try {
        const updatedBatch = await api.startBatchProcessing(batchId, responsibleSpecialistId)
        commit(UPDATE_BATCH, updatedBatch)

        NotificationService.success(`Run processing was successfully started`)
        started = true
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to start run processing. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'startBatchProcessing', value: false})

    return started
}

export const printLabels = async ({state, dispatch, commit}, batchId) => {
    if (state.progress['labelsPrinting']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'labelsPrinting', value: true})

    try {
        await api.printLabels(batchId)

        NotificationService.success(`Labels was successfully sent to print`)
    } catch (e) {
        NotificationService.error(`Unable to send label to printer. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'labelsPrinting', value: false})
}

export const deleteSampleFromBatches = async ({state, dispatch, commit}, sampleBatch) => {
    for (let batchId in state.sampleBatchesByBatchId) {
        if (!state.sampleBatchesByBatchId.hasOwnProperty(batchId)) {
            continue
        }

        let sampleBatches = state.sampleBatchesByBatchId[batchId]

        for (let position in sampleBatches) {
            if (!sampleBatches.hasOwnProperty(position)) {
                continue
            }

            let sb = sampleBatches[position]

            if (sb.sampleId === sampleBatch.sampleId) {
                commit(REMOVE_SAMPLE_BATCH, {position: position, batchId: batchId})
            }
        }
    }
}

export const exportBatchToCsv = async ({state, dispatch, commit}, reportId) => {
    if (state.progress['exportBatchToCsv']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'exportBatchToCsv', value: true})

    let reportPdf = false

    try {
        reportPdf = await api.exportBatchToCsv(reportId)
    } catch (e) {
        console.log(`Unable to export run to csv, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'exportBatchToCsv', value: false})

    return reportPdf
}

export const exportBatchSamplesToXlsx = async ({state, dispatch, commit}, reportId) => {
    if (state.progress['exportBatchSamplesToXlsx']) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'exportBatchSamplesToXlsx', value: true})

    let exportInfo = false

    try {
        exportInfo = await api.exportBatchSamplesToXlsx(reportId)
    } catch (e) {
        console.log(`Unable to export run samples to xlsx, details: ${e.message}`)
    }

    commit(CHANGE_PROGRESS, {context: 'exportBatchSamplesToXlsx', value: false})

    return exportInfo
}

export const addFileToBatch = async({state, dispatch, commit}, {batchId, fileId}) => {
    try {
        const files = await api.addFileToBatch(batchId, fileId)
        commit(UPDATE_BATCH_FILES, {
            batchId: batchId,
            files: files,
        })
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to add file to run. Try again later`))
    }
}

export const deleteFileFromBatch = async({state, dispatch, commit}, {batchId, fileId}) => {
    try {
        const files = await api.deleteFileFromBatch(batchId, fileId)
        commit(UPDATE_BATCH_FILES, {
            batchId: batchId,
            files: files,
        })
    } catch (e) {
        NotificationService.error(extractUserErrorMessage(e, `Unable to delete file from run. Try again later`))
    }
}

export const afterApplicationInit = {
    root: true,
    async handler(namespacedContext) {
        const availableBatchStatusesByValue = _.keyBy(namespacedContext.state.availableBatchStatuses, 'value')
        namespacedContext.commit(UPDATE_AVAILABLE_BATCH_STATUSES_BY_VALUE, availableBatchStatusesByValue)
    }

}
